/**
 * useAccountType hook
 * 
 * Provides the current user's account type and helper booleans.
 * Account types: "saas" | "biotag" | "full" (default: "full")
 * 
 * - saas: ERP-only, no BioTag hardware
 * - biotag: Sensor-only
 * - full: Both ERP + BioTag
 */
import { useAuth } from "../contexts/AuthContext";

export const ACCOUNT_TYPES = {
  SAAS: "saas",
  BIOTAG: "biotag",
  FULL: "full",
};

export function useAccountType() {
  const { userData } = useAuth();

  const accountType = userData?.AccountType || ACCOUNT_TYPES.FULL;

  return {
    accountType,
    isSaas: accountType === ACCOUNT_TYPES.SAAS,
    isBioTag: accountType === ACCOUNT_TYPES.BIOTAG,
    isFull: accountType === ACCOUNT_TYPES.FULL,
    /** Whether BioTag hardware features should be shown */
    hasBioTag: accountType === ACCOUNT_TYPES.BIOTAG || accountType === ACCOUNT_TYPES.FULL,
    /** Whether ERP/herd management features should be shown */
    hasERP: accountType === ACCOUNT_TYPES.SAAS || accountType === ACCOUNT_TYPES.FULL,
  };
}
